import { Ref } from 'react';
import styled from 'styled-components';

import { AceEditorTheme } from 'modules/aceEditor';
import { extraLargeShadow, mediumShadow, zIndex, spacing } from 'ui/theme';
import { testIds, toolbarTheme } from '../../constants';
import { useSideBySideEditorContext } from '../../contexts/SideBySideEditorContext';
import { EditButtons } from './editButtons';
import { InsertButtons } from './insertButtons';

const Wrapper = styled.div<{ $aceEditorTheme: AceEditorTheme }>`
  align-items: flex-start;
  background-color: ${({ $aceEditorTheme: $theme }) => toolbarTheme[$theme].bgColor};
  border-bottom: ${({ $aceEditorTheme: $theme, theme }) =>
    `${theme.spacing.single} solid ${toolbarTheme[$theme].borderColor}`};
  column-gap: ${spacing.fiveEights};
  display: flex;
  flex-wrap: wrap;
  row-gap: ${spacing.fiveEights};
  padding: ${spacing.fiveEights};
  position: relative; /** necessary for the shadow */
  z-index: ${zIndex.toolbar}; /** necessary for the shadow */
  ${extraLargeShadow};
  ${({ $aceEditorTheme: $theme }) =>
    toolbarTheme[$theme].shadow === 'XL' ? extraLargeShadow : mediumShadow};

  & > section {
    align-items: center;
    column-gap: ${spacing.fiveEights};
    display: flex;
    flex-wrap: wrap;
    &:last-child {
      flex: 1 1 auto;
      justify-content: flex-end;
    }
  }
`;

type ToolbarProps = {
  innerRef: Ref<HTMLDivElement>;
};

export const Toolbar = ({ innerRef }: ToolbarProps) => {
  const { aceEditorTheme } = useSideBySideEditorContext();

  return (
    <Wrapper data-test={testIds.toolbar} ref={innerRef} $aceEditorTheme={aceEditorTheme}>
      <InsertButtons />
      <EditButtons />
    </Wrapper>
  );
};
